<template>
	<div class="common">
		
		<el-container>
			<!-- 头部 -->
			<el-header>
				<div class="header2">
					<div class="header2-left">
						<div>
							<router-link to="/index">首页</router-link>
						</div>
						<div>
							<router-link to="/game/list" >竞赛</router-link>
						</div>
						<div>
							<router-link to="/question/ku_list" >题库</router-link>
						</div>
						<div>
							<router-link to="/question/ti_list" >题型</router-link>
						</div>
						<div>
							<router-link to="/article/list" >文章</router-link>
						</div>
					</div>
					<div class="header2-right" v-if="info.length==0">
						<div>
							<router-link to="/register" >
							注册
							</router-link>
						</div>
						<div>
							<router-link to="/login" >
							登录
							</router-link>
						</div>
						
					</div>
					<div class="header2-right"  v-else>
						<router-link to="/user" >
						{{info.username}}
						</router-link>
						
						<div class="quit"  @click="quit()">
							退出登录
						</div>
					</div>
				</div>
			</el-header>  
			<router-view></router-view>   
		
		</el-container>
		
	</div>
</template>

<script>
	

	export default {
	    data() {
			return {
				info  : [],
				
			}
		},
	    created() {	
			let that  = this;
			
			that.$http('get','/api/v1/user/userinfos',{}) .then(function (res) {
				console.log(res.data==null);
				that.info  = res.data!=null ? res.data : [];
				
			});
	    },
		methods:{
			quit(){
				let that = this;
				this.$confirm('是否退出登录?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					that.$http('post','/api/v1/userlogin/quit',{}) .then(function (res) {
						that.$message({
							type: 'success',
							message: '退出登录成功!'
						});
						localStorage.token = '';
						that.info  =  [];
						that.$router.push('/');	
					});
				  
				});
			}
		},
	
	}	

</script>
<style lang="less">
	.common {
		// width: 100%;
		margin-left: auto;
		margin-right: auto;
		color:#000000;
		font-size: 14px;
		background-color: #FFFFFF;
		    // box-shadow: 0 0 10px #bfbfbf;
	}
	.el-header {
		display: flex;
		box-shadow: 0 0 10px #bfbfbf;
		border-bottom: 1px solid rgba(233, 233, 233, 1);
	}
	.el-header i {
		padding-right: 10px;
		width: 20px;
		height: 20px;
		text-align: center;
		
	}
	.el-header .header2 {
		// margin-left: auto;
		line-height: 60px;
		display: flex;
		.header2-left {
			// flex: 2;
			padding-left: 18.75rem;
			display: flex;
			width: 48rem;
			
			div {
				width: 40px;
				font-weight: 500;
				padding-left: 10px;
				padding-right: 10px;
				a {
					color:#000000;
					font-size: 0.9rem;
					outline: none;
				}
			}
		}
		.header2-right {
			// flex: 1;
			text-align: right;
			// width: 21.5rem;
			display: flex;
			a {
				padding-left: 1rem;
				font-size: 0.9rem;
			}
			.quit {
				font-size: 0.6rem;
				padding-left: 2rem;
				color: #9a9b9a;
			}
		
		}
		
	}
	
	
	 .el-footer {
	    background-color: #B3C0D1;
	    color: #333;
	    text-align: center;
	    line-height: 60px;
	  }
	  
	  .el-aside {
	    background-color: #FFFFFF;
	    color: #333;
	    text-align: center;
	   /* line-height: 200px; */
		height: 360px;
	
		border-radius: 10px;
		border: 1px solid rgba(233, 233, 233, 1);
		box-shadow: 0 0 5px #FFF0FF;
	  }
	  
	  .el-main {
		  margin-left: 30px;
		  padding: 0;
		  	overflow:visible;
	   /* background-color: #E9EEF3;
	    color: #333;
	    text-align: center;
	    line-height: 160px;
		 */
	  }
	  
	  body > .el-container {
	    margin-bottom: 40px;
	  }
	  
	  .el-container:nth-child(5) .el-aside,
	  .el-container:nth-child(6) .el-aside {
	    line-height: 260px;
	  }
	  
	  .el-container:nth-child(7) .el-aside {
	    line-height: 320px;
	  }
</style>
